"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFormattedCurrency = getFormattedCurrency;
var _formatNumber = require("../formatters/formatNumber");
var _getFormattedNumber = require("./getFormattedNumber");
var _makeSpacesNonBreakable = require("./makeSpacesNonBreakable");
var _replacePattern = require("./replacePattern");
/**
 * Formats the currency based on the {@link culture} and {@link financialSet financial setting}.
 * @param value Value to format
 * @param culture Culture settings containing formatting rules
 * @param financialSet Financial settings containing currency specification
 * @returns An object containing a {@link formattedCurrency formatted currency} and a {@link formattedDoubleCurrency formatted double currency} on double currency market
 */
function getFormattedCurrency(value, culture, financialSet) {
  const {
    currencyFormat
  } = culture ?? {};
  const {
    currencySymbol,
    doubleCurrency
  } = financialSet ?? {};
  const currencyPattern = value < 0 ? currencyFormat?.negativePattern : currencyFormat?.positivePattern;
  if (!currencyFormat || !currencyPattern) {
    // it is preferred by the business to display the value formatted in the runtime culture than no value at all
    const unknownCurrency = (0, _formatNumber.formatNumber)(value, culture);
    return {
      formattedCurrency: unknownCurrency,
      currencies: [unknownCurrency]
    };
  }
  const formattedCurrency = (0, _makeSpacesNonBreakable.makeSpacesNonBreakable)((0, _replacePattern.replacePattern)(currencyPattern, {
    n: (0, _getFormattedNumber.getFormattedNumber)(value, currencyFormat.decimals, currencyFormat.decimalSeparator, currencyFormat.groupSizes, currencyFormat.groupSeparator, {
      removeTrailingZeros: currencyFormat.removeTrailingZeros
      // we can't use the negative pattern here because currencies have different positive and negative formatting pattern than decimals
    }),
    $: currencySymbol ?? ''
  }));
  if (!doubleCurrency) {
    return {
      formattedCurrency,
      currencies: [formattedCurrency]
    };
  }
  const doubleCurrencyPattern = value < 0 ? doubleCurrency.negativePattern : doubleCurrency.positivePattern;
  const formattedDoubleCurrency = (0, _makeSpacesNonBreakable.makeSpacesNonBreakable)(
  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing -- Logical assignment helps with an empty (unfilled) double currency pattern
  (0, _replacePattern.replacePattern)(doubleCurrencyPattern || currencyPattern, {
    n: (0, _getFormattedNumber.getFormattedNumber)(value * doubleCurrency.exchangeRate, doubleCurrency.decimals, doubleCurrency.decimalSeparator ? doubleCurrency.decimalSeparator : currencyFormat.decimalSeparator, currencyFormat.groupSizes, doubleCurrency.groupSeparator ? doubleCurrency.groupSeparator : currencyFormat.groupSeparator, {
      removeTrailingZeros: doubleCurrency.removeTrailingZeros
      // we can't use the negative pattern here because currencies have different positive and negative formatting pattern than decimals
    }),
    $: doubleCurrency.currencySymbol ?? ''
  }));
  return {
    formattedCurrency,
    formattedDoubleCurrency,
    currencies: [formattedDoubleCurrency, formattedCurrency]
  };
}
